module.exports = __webpack_public_path__ + "static/media/wet.fdcbb582.png";